import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Listas } from './pages/Listas';
import { ListaDetalle } from './pages/ListaDetalle';
import { Candidatos } from './pages/Candidatos';
import { FichaCandidato } from './pages/FichaCandidato';
import { Validacion } from './pages/Validacion';
import { PortalCandidato } from './pages/PortalCandidato';
import { Avance } from './pages/Avance';
import { Padron } from './pages/Padron';
import { Normativa } from './pages/Normativa';
import { ExpedienteJeeDashboard } from './pages/ExpedienteJeeDashboard';
import { Coordinadores } from './pages/Coordinadores';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { useAuth } from './store/auth';

function HomeRedirect() {
  const { rol, candidatoId } = useAuth();
  if (rol === 'CAN') {
    return <Navigate to={candidatoId ? `/candidatos/${candidatoId}` : '/portal'} replace />;
  }
  return <Navigate to="/dashboard" replace />;
}

function StaffOnly({ children }: { children: React.ReactNode }) {
  const { rol, candidatoId } = useAuth();
  if (rol === 'CAN') {
    return <Navigate to={candidatoId ? `/candidatos/${candidatoId}` : '/portal'} replace />;
  }
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/portal" element={<PortalCandidato />} />
        {/* Rutas staff-only — CAN no puede acceder */}
        <Route path="/dashboard" element={<StaffOnly><Dashboard /></StaffOnly>} />
        <Route path="/listas" element={<StaffOnly><Listas /></StaffOnly>} />
        <Route path="/listas/:id" element={<StaffOnly><ListaDetalle /></StaffOnly>} />
        <Route path="/candidatos" element={<StaffOnly><Candidatos /></StaffOnly>} />
        <Route path="/validacion" element={<StaffOnly><Validacion /></StaffOnly>} />
        <Route path="/avance" element={<StaffOnly><Avance /></StaffOnly>} />
        <Route path="/padron" element={<StaffOnly><Padron /></StaffOnly>} />
        <Route path="/normativa" element={<StaffOnly><Normativa /></StaffOnly>} />
        <Route path="/expediente-jee" element={<StaffOnly><ExpedienteJeeDashboard /></StaffOnly>} />
        <Route path="/coordinadores" element={<StaffOnly><Coordinadores /></StaffOnly>} />
        {/* /candidatos/:id es accesible para CAN (solo ve el suyo · RBAC backend) */}
        <Route path="/candidatos/:id" element={<FichaCandidato />} />
      </Route>
      <Route path="*" element={<HomeRedirect />} />
    </Routes>
  );
}
